module.exports = __webpack_public_path__ + "img/public_activities_3.d4bb57e8.png";